import React from "react";
import languages from "../../../data/languages";

export const languageTemplate = {
  description: "",
  language: "",
  name: "",
  priceName: ""
};

const Translations = ({
                        className = "row",
                        translations,
                        onChange
                      }) => (
  <div className={className}>
    {Object.keys(languages)
      .map(lang => {
        const languageItem = translations.find(i => i.language === lang) || {};
        return (
          <div key={lang} className="col-4">
            <label>{languages[lang]}</label>

            <div className="form-group">
              <input
                className="form-control form-control-sm"
                type="text"
                value={languageItem.name || ""}
                onChange={ev => onChange(lang, "name", ev.target.value)}
                placeholder="Title"
              />
            </div>
            <div className="form-group">
                      <textarea
                        className="form-control form-control-sm"
                        value={languageItem.description || ""}
                        onChange={ev => onChange(lang, "description", ev.target.value)}
                        placeholder="Description"
                      />
            </div>
            <div className="form-group">
              <input
                className="form-control form-control-sm"
                type="text"
                value={languageItem.priceName || ""}
                onChange={ev => onChange(lang, "priceName", ev.target.value)}
                placeholder="Price name"
              />
            </div>
          </div>
        );
      })}
  </div>
);

export default React.memo(Translations);



// WEBPACK FOOTER //
// ./src/views/pages/tariff/translations.js